import { useQuery } from 'react-query'
import { fetchAppleOriginals } from '../services/api'

export const useAppleOriginals = options => {
  return useQuery('appleOriginals', fetchAppleOriginals, options)
}
